module.exports = __webpack_public_path__ + "img/Sonder2019.4ec76b06.jpg";